export enum Suit {
  HEARTS = 'HEARTS',
  DIAMONDS = 'DIAMONDS',
  SPADES = 'SPADES',
  CLUBS = 'CLUBS'
}

export enum CardValue {
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
  SIX = 6,
  SEVEN = 7,
  EIGHT = 8,
  NINE = 9,
  TEN = 10,
  JACK = 11,
  QUEEN = 12,
  KING = 13,
  ACE = 14
}

export interface Card {
  suit: Suit;
  value: CardValue;
}

export interface WrapResult {
  outs: number;
  nutOuts: number;
}

export const suitToSymbol = {
  [Suit.HEARTS]: '♥',
  [Suit.DIAMONDS]: '♦',
  [Suit.SPADES]: '♠',
  [Suit.CLUBS]: '♣'
};

export const valueToString = (value: CardValue): string => {
  switch (value) {
    case CardValue.ACE:
      return 'A';
    case CardValue.KING:
      return 'K';
    case CardValue.QUEEN:
      return 'Q';
    case CardValue.JACK:
      return 'J';
    case CardValue.TEN:
      return 'T';
    default:
      return value.toString();
  }
}; 